import { Text } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';
import React from 'react';

import { AwayStatus } from 'apis/presence';
import styles from 'components/presence/components/presenceList.module.scss';
import { PresenceListItem } from 'components/presence/components/presenceListItem';
import { TeamWithMembers } from 'components/presence/components/presenceListSections';
import { PresenceSectionSkeleton } from 'components/presence/components/presenceSectionSkeleton';
import { PresenceSectionWarning } from 'components/presence/components/presenceSectionWarning';

type TeamPresenceListSectionsProps = {
  profile: User;
  awayStatuses: AwayStatus[];
  teams: TeamWithMembers[];
  loading: boolean;
  error: boolean;
  favouriteTeamMemberIds: string[];
  onAddToFavorites: (userId: string) => void;
  onRemoveFromFavorites: (userId: string) => void;
};

export const TeamPresenceListSections = ({
  profile,
  awayStatuses,
  teams,
  loading,
  error,
  favouriteTeamMemberIds,
  onAddToFavorites,
  onRemoveFromFavorites,
}: TeamPresenceListSectionsProps): JSX.Element => {
  if (error) {
    return <PresenceSectionWarning title="Loading team members failed.." />;
  }

  if (loading) {
    return (
      <>
        <PresenceSectionSkeleton />
        <PresenceSectionSkeleton />
      </>
    );
  }

  return (
    <>
      {teams.map((team) => (
        <React.Fragment key={team.id}>
          <li className={styles.groupHead}>
            <Text.Paragraph
              variant="3"
              color="var(--sidebar-text-color-secondary)"
            >
              {team.name} ({team.members.length})
            </Text.Paragraph>
          </li>
          <ul className={styles.list}>
            {team.members.map((member) => (
              <PresenceListItem
                key={member.id}
                member={member}
                ownProfile={profile}
                awayStatuses={awayStatuses}
                isFavorite={favouriteTeamMemberIds.includes(member.id)}
                onAddToFavorites={onAddToFavorites}
                onRemoveFromFavorites={onRemoveFromFavorites}
              />
            ))}
          </ul>
        </React.Fragment>
      ))}
    </>
  );
};
